import { AccCheckerPaneProps } from './components/AccCheckerPane';
import { AccCheckerPluginInterface } from './plugin/AccCheckerPlugin';
import AccCheckerPlugin from './plugin/AccCheckerPlugin';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AccCheckerPlugin" */ './lazyIndex')
);

export type LazyAccCheckerPlugin = LazyPlugin<AccCheckerPlugin>;

export const LazyAccCheckerPluginClass = createLazyPlugin(
    lazyModule,
    m => m.AccCheckerPlugin,
    'AccChecker',
    null
);

// Types
export { LazyPlugin, AccCheckerPluginInterface, AccCheckerPaneProps };

export const AccCheckerPane = createLazyComponent(lazyModule, m => m.AccCheckerPane);
